import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-concrete">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
